import { Tag } from 'antd';
import styled from 'styled-components';

interface CodeTagProps {
  color: string;
  small: boolean;
}

export const CodeTag = styled(Tag)<CodeTagProps>`
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 12px;
  margin-right: 0;
`;
